var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapPinLocationRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.475 10.271a6.205 6.205 0 0 0-6.203-6.203 6.205 6.205 0 0 0-6.204 6.203c0 .535.194 1.362.659 2.465.452 1.068 1.094 2.248 1.831 3.442 1.228 1.99 2.65 3.911 3.714 5.281 1.068-1.37 2.49-3.291 3.713-5.281.737-1.194 1.379-2.374 1.831-3.442.465-1.103.66-1.93.66-2.465zm2.068 0c0 3.766-5.04 10.469-7.25 13.235-.53.659-1.513.659-2.042 0C10.04 20.74 5 14.036 5 10.27A8.274 8.274 0 0 1 13.272 2a8.274 8.274 0 0 1 8.271 8.271zm-6.893 0a1.379 1.379 0 1 0-2.757 0 1.379 1.379 0 0 0 2.757 0zm-4.825 0a3.446 3.446 0 1 1 6.893 0 3.446 3.446 0 0 1-6.893 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapPinLocationRegular);
export default __webpack_public_path__ + "static/media/icon-map-pin-location-regular.32acd62c.svg";
export { ForwardRef as ReactComponent };